export enum Role {
  PROD_USER = '5ca832f7-715a-4382-aa07-9db043ce02f4',
  BETA_USER = '8f2ad0e9-e1b7-4409-9508-2ef1d91d57fc',
  NONPROD_USER = '8a38e87f-7c01-46c3-9a47-2a1bda323b46',
  TRAINING_USER = '0554b476-3e1c-4f00-9dc1-be0aa90cfc58',

  TEMPORARY_DUTY_AGENT = 'ebd1f9df-a38a-466f-a0a6-4dffd3c556e9',
  STATION_AGENT = '3a3548c0-4178-4b89-9ee7-494e8b246689', // current ace ad group
  DEVELOPER = 'b72f127e-1189-4c21-b9ad-372a4c72b0e3',
}

export function getRoles(groupIds: string[]): Role[] {
  const roles: Role[] = []

  for (const key of Object.values(Role)) {
    const role = key as Role

    if (groupIds.includes(role)) {
      roles.push(role)
    }
  }
  return roles
}

export function getRoleKeys(adGroups: string[]) {
  const groupNames: string[] = []
  for (const [key, value] of Object.entries(Role)) {
    if (adGroups && adGroups.includes(value)) {
      groupNames.push(key)
    }
  }
  return groupNames
}
